<div>
  <button
    #anchor
    (click)="togglePopup()"
    kendoButton
    [disabled]="disabled()"
  >
    @if (isLoadingSeveritySummary) {
    <kendo-loader
      type="converging-spinner"
      size="small"
    ></kendo-loader>
    } @else if(disabled()) {
    <kendo-svgicon [icon]="bellIcon"></kendo-svgicon>
    }@else if ((severitySummary | async)?.length) {
    <div
      class="row"
      style="align-items: center; gap: 5px"
    >
      @for (summary of (severitySummary | async); track summary.severity; let last = $last) {

      <app-notification-severity-icon
        [severity]="summary.severity"
        [size]="'small'"
      ></app-notification-severity-icon>
      {{ summary.count }}@if (!last) {
      <span>|</span>
      } }
    </div>
    } @else {
    <kendo-svgicon
      [icon]="bellIcon"
      themeColor="success"
    ></kendo-svgicon>
    }
  </button>
</div>

@if (showPopup) {
<kendo-popup
  [anchor]="anchor"
  [anchorAlign]="anchorAlign"
  [popupAlign]="popupAlign"
  [margin]="margin"
  (anchorViewportLeave)="showPopup = false"
  class="popup k-elevation-1"
>
  <div class="notification-section">
    <div class="section-header">
      {{ 'Notification.PersistedNotifications' | translate }}
      <div style="flex-grow: 1"></div>
      <button
        kendoButton
        [svgIcon]="checkCircleIcon"
        [size]="'small'"
        [fillMode]="'flat'"
        [themeColor]="'primary'"
        (click)="signAllNotifications()"
        title="{{ 'Notification.MarkAllAsRead' | translate }}"
      ></button>
      <button
        kendoButton
        [svgIcon]="gridIcon"
        [size]="'small'"
        [fillMode]="'flat'"
        [themeColor]="'primary'"
        title="{{ 'Notification.ViewAllNotifications' | translate }}"
        (click)="navigateToGrid()"
      ></button>
    </div>
    <div class="section-content-persisted">
      @if (isLoadingNotificationsPersisted) {
      <div class="k-p-3 k-d-flex k-justify-content-center">
        <kendo-loader
          type="converging-spinner"
          size="medium"
        ></kendo-loader>
      </div>
      } @else { @if ((notificationsPersisted | async)?.data?.length === 0) {
      <div class="k-p-3 k-text-center k-text-muted k-text-sm">
        {{ 'Notification.NoPersistedNotifications' | translate }}
      </div>
      } @for (n of (notificationsPersisted | async)?.data; track n) {
      <app-notification-item
        [notification]="n"
        [actionIcon]="checkIcon"
        [actionTitle]="'Remove'"
        [actionThemeColor]="'success'"
        (action)="sign(n)"
        (close)="togglePopup()"
      ></app-notification-item>
      } }
    </div>
  </div>
  <div class="notification-section">
    <div class="section-header row">
      {{ 'Notification.SessionNotifications' | translate }}
      <div style="flex-grow: 1"></div>
      <button
        kendoButton
        [svgIcon]="trashIcon"
        themeColor="primary"
        (click)="clearAll()"
        title="{{ 'EntityTranslation.Remove' | translate }}"
      ></button>
    </div>
    <div class="section-content-session">
      @if (sessionNotifications?.length === 0) {
      <div class="k-p-3 k-text-center k-text-muted k-text-sm">
        {{ 'Notification.NoSessionNotifications' | translate }}
      </div>
      } @for (n of sessionNotifications; track n) {
      <app-notification-item
        [notification]="n"
        [actionIcon]="xIcon"
        [actionTitle]="'Remove'"
        [actionThemeColor]="'warning'"
        (action)="removeNotification(n)"
      ></app-notification-item>
      }
    </div>
  </div>
</kendo-popup>
}
